import React, { Component } from "react";
import API from "../utils/api";
import { formatDate } from "../utils/dateFormatter";
import RecordingCell from "../components/RecordingCell";

class ExecutiveFlaggedLeads extends Component {
    state = {
        leads: [],
        count: 0,
        loading: true,
        page: 0,
        pageSize: 50,
        audioProgress: {},
    };

    componentDidMount() {
        this.fetchReport();
    }

    handleAudioProgress = (leadId, currentTime, duration) => {
        this.setState(prevState => {
            const prev = prevState.audioProgress[leadId] || { currentTime: 0, duration: 0 };
            return {
                audioProgress: {
                    ...prevState.audioProgress,
                    [leadId]: {
                        currentTime: Math.max(prev.currentTime, currentTime),
                        duration: duration || prev.duration
                    }
                }
            };
        });
    };

    fetchReport = async () => {
        this.setState({ loading: true });
        try {
            const { page, pageSize } = this.state;
            const params = { limit: pageSize, offset: page * pageSize };

            const res = await API.get("/executive/report/flagged", { params });
            const data = res.data.data || res.data;
            this.setState({
                leads: data.leads || [],
                count: data.count || 0,
                loading: false,
            });
        } catch (e) {
            console.error("Failed to fetch flagged leads", e);
            this.setState({ loading: false });
        }
    };

    handlePageChange = (newPage) => {
        this.setState({ page: newPage }, this.fetchReport);
    };

    render() {
        const { leads, loading, count, page, pageSize } = this.state;
        const totalPages = Math.ceil(count / pageSize);

        return (
            <div>
                <h2 className="page-header">
                    <i className="fas fa-flag text-danger"></i> Flagged Leads Report
                </h2>

                <div className="well" style={{ padding: '15px', marginBottom: '20px' }}>
                    <p className="mb-0 text-muted">
                        This page shows all the leads where you have been flagged during the call audit process.
                        Review the feedback carefully to improve your call quality.
                    </p>
                </div>

                {loading ? (
                    <div className="text-center"><i className="fas fa-spinner fa-spin fa-2x"></i></div>
                ) : (
                    <div>
                        <p>Total Flagged Leads: <strong>{count}</strong></p>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th style={{ minWidth: 200 }}>Original Message</th>
                                        <th style={{ minWidth: 200 }}>Message</th>
                                        <th>Service & Medicine Type</th>
                                        <th>Service For</th>
                                        <th>Posted On</th>
                                        <th>Recording</th>
                                        <th>Score</th>
                                        <th style={{ minWidth: 200 }}>Remark</th>
                                        <th style={{ minWidth: 150 }}>Issues Identified</th>
                                        <th>Audit Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {leads.length === 0 ? (
                                        <tr><td colSpan="10" className="text-center">No flagged leads found</td></tr>
                                    ) : (
                                        leads.map((lead) => (
                                            <tr key={lead.id}>
                                                <td>{lead.id}</td>
                                                <td>{lead.original_message || "-"}</td>
                                                <td>{lead.message || "-"}</td>
                                                <td>
                                                    <div><strong>Service:</strong> {lead.service_type || "-"}</div>
                                                    <div><strong>Medicine:</strong> {lead.medicine_type || "-"}</div>
                                                </td>
                                                <td>{lead.service_for || "-"}</td>
                                                <td>{formatDate(lead.posted_on)}</td>
                                                <td>
                                                    <RecordingCell
                                                        leadId={lead.id}
                                                        allocationId={null}
                                                        recordingUrls={lead.recording_urls}
                                                        onAudioProgress={this.handleAudioProgress}
                                                    />
                                                </td>
                                                <td><strong>{lead.audit_score}/10</strong></td>
                                                <td>{lead.audit_remark || "-"}</td>
                                                <td>
                                                    <ul className="list-unstyled mb-0" style={{ fontSize: '0.9em' }}>
                                                        {lead.communication_issue === 1 && <li className="text-danger"><i className="fa fa-times"></i> Communication</li>}
                                                        {lead.product_knowledge_issue === 1 && <li className="text-danger"><i className="fa fa-times"></i> Product Knowledge</li>}
                                                        {lead.verification_compliance_issue === 1 && <li className="text-danger"><i className="fa fa-times"></i> Checklist Compliance</li>}
                                                        {lead.accuracy_issue === 1 && <li className="text-danger"><i className="fa fa-times"></i> Accuracy of Info</li>}
                                                        {lead.call_etiquette_issue === 1 && <li className="text-danger"><i className="fa fa-times"></i> Call Etiquette</li>}
                                                    </ul>
                                                </td>
                                                <td>{formatDate(lead.audit_date)}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {totalPages > 1 && (
                            <nav className="text-center">
                                <ul className="pagination">
                                    <li className={page === 0 ? "disabled" : ""}>
                                        <a href="#prev" onClick={(e) => { e.preventDefault(); if (page > 0) this.handlePageChange(page - 1); }}>&laquo;</a>
                                    </li>
                                    {[...Array(totalPages).keys()].map((p) => {
                                        // Show max 10 pages pagination
                                        if (p < page - 5 || p > page + 5) return null;
                                        return (
                                            <li key={p} className={page === p ? "active" : ""}>
                                                <a href={`#page-${p}`} onClick={(e) => { e.preventDefault(); this.handlePageChange(p); }}>{p + 1}</a>
                                            </li>
                                        );
                                    })}
                                    <li className={page >= totalPages - 1 ? "disabled" : ""}>
                                        <a href="#next" onClick={(e) => { e.preventDefault(); if (page < totalPages - 1) this.handlePageChange(page + 1); }}>&raquo;</a>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default ExecutiveFlaggedLeads;
